export default "__VITE_ASSET__CwHeCouo__"